import { ReviewGetters, AgnosticRateCount } from '@vue-storefront/core';
import type { Review, ReviewItem } from '@bee-hole/api';
interface ExtendedReviewGetters<R, RI> extends ReviewGetters<R, RI> {
  getReviewImages: (item: ReviewItem) => string[]; // 新方法
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function getItems(review: Review): ReviewItem[] {
  return [];
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function getReviewId(item: ReviewItem): string {
  return String(item?.reviewId);
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function getReviewAuthor(item: ReviewItem): string {
  return item?.nick;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function getReviewMessage(item: ReviewItem): string {
  return item?.reviewContent;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function getReviewRating(item: ReviewItem): number {
  return item?.grade;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function getReviewDate(item: ReviewItem): string {
  return item?.createTime;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function getTotalReviews(review: Review): number {
  return 0;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function getAverageRating(review: Review): number {
  return 0;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function getRatesCount(review: Review): AgnosticRateCount[] {
  return [];
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function getReviewsPage(review: Review): number {
  return 0;
}
function getReviewImages(item: ReviewItem): string[] {
  if (item) {
    return [
      item.imageUrl1,
      item.imageUrl2,
      item.imageUrl3,
      item.imageUrl4,
      item.imageUrl5
    ].filter(Boolean);
  }
}

export const reviewGetters: ExtendedReviewGetters<Review, ReviewItem> = {
  getItems,
  getReviewId,
  getReviewAuthor,
  getReviewMessage,
  getReviewRating,
  getReviewDate,
  getTotalReviews,
  getAverageRating,
  getRatesCount,
  getReviewsPage,
  getReviewImages
};
